import ViewCircular from "@/components/ViewCircular/ViewCircular";
import { useAppDispatch } from "@/config/store";
import { Card, CardContent, List, ListItem, ListItemIcon, ListItemText } from "@/components/ui";
import { IEdoCircular } from "@/shared/model/edo-circular.model";
import { Megaphone } from "lucide-react";
import axios from "axios";
import { useEffect, useState } from "react";
import { Translate } from "react-jhipster";
// import { getLoginUrl, REDIRECT_URL } from '@/shared/util/url-utils';

export const Circolari = () => {
  const dispatch = useAppDispatch();
  // const { entities: circulars } = useAppSelector<
  //   EntityState<IEdoCircular>
  //   >((state) => state.edoCircular);
  const [circulars, setCirculars] = useState<IEdoCircular[]>([]);
  const [viewCircularDialog, setViewCircularDialog] = useState<{ open: boolean; entity: IEdoCircular }>({ open: false, entity: null });

  const getAllEntities = async () => {
    // dispatch(getCircolareList({ page: 0, size: 5, sort: `dataCreation:DESC` }));
    const response = await axios.get<{ data: IEdoCircular[] }>(`/account/circulars`, {
      params: {
        page: 0,
        size: 5,
        sort: `dataCreation:DESC`,
      },
    });
    setCirculars(response.data.data);
  };

  useEffect(() => {
    getAllEntities();
  }, []);

  return (
    <>
      <Card className="overflow-hidden rounded-3xl border border-[var(--color-mockup-border)] p-0 shadow-card">
        <div className="border-b border-[var(--color-mockup-border)] bg-[var(--color-surface-secondary)]/30 px-5 py-3">
          <p className="text-sm font-heading font-bold text-[var(--color-mockup-text)]">Circolari</p>
        </div>
        <CardContent className="p-0 last:pb-0">
          <List className="divide-y divide-[var(--color-mockup-border)]">
            {circulars.length > 0 ? (
              circulars.map((circular) => (
                <ListItem
                  key={circular.id}
                  className="flex cursor-pointer items-center gap-3 px-5 py-2.5 transition-colors hover:bg-primary/5"
                  onClick={() => setViewCircularDialog({ open: true, entity: circular })}
                >
                  <ListItemIcon className="shrink-0">
                    <div className="flex h-8 w-8 items-center justify-center rounded-3xl bg-primary/10 text-primary">
                      <Megaphone className="h-4 w-4" />
                    </div>
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <span className="text-sm font-medium text-[var(--color-mockup-text)] line-clamp-2">
                        {circular.title}
                      </span>
                    }
                  />
                </ListItem>
              ))
            ) : (
              <div className="px-5 py-4 text-center text-sm text-[var(--color-mockup-text-mid)]">
                <Translate contentKey="edocendoApp.edoCircular.home.notFound" />
              </div>
            )}
          </List>
        </CardContent>
      </Card>
      <ViewCircular
        open={viewCircularDialog.open}
        circular={viewCircularDialog.entity}
        onClose={() => setViewCircularDialog({ open: false, entity: null })}
      />
    </>
  );
};

export default Circolari;
